// extracted by mini-css-extract-plugin
export default {"check":"Checkbox_check__9aVXy","on":"Checkbox_on__8qddA","some":"Checkbox_some__gEriu"};